@if (showCriticalError) {
    <div id="critical-error">
        <div class="error-header">{{ criticalError.header }}</div>
        <span class="error-text" (click)="reloadPage()">{{ criticalError.text }}</span>
    </div>
}
